<div class="agpr-themeAnalytics">
    <h2 class="u-srOnly">
        {{ themeName ?
            ('Social.intelligence.theme.analytics.heading' | localize: {name: themeName})
            : ('Social.intelligence.archive.analytics.heading' | localize) }}
    </h2>
    <div class="agpr-themeAnalytics-toolbar" role="group" [attr.aria-label]="'Social.intelligence.theme.analytics.toolbar.control' | localize">
        <h3 class="u-srOnly">{{ 'toolbar' | localize }}</h3>
        <agpr-message
            *ngIf="isArchiveSearch"
            [severity]="messageSeverity.info"
            [style]="agprComponentStyle.social"
        >
            {{ 'Social.agentWidget.archiveSearch.results.message'  | localize }}
        </agpr-message>
        <div class="agpr-themeAnalytics-toolbarRow agpr-themeAnalytics-toolbar-topRow">
            <!-- Filter -->
            <agpr-social-filter-input
                class="agpr-themeAnalytics-toolbar-filter"
                id="theme.filters"
                [showQuickFilter]="true"
                [style]="agprComponentStyle.socialPlus"
                quickFilterPlaceholder="Social.filter.quickFilter.placeholder"
                iconClass="fa-regular fa-duotone fa-filter"
                [ariaDescribedBy]="'theme.filters'"
            ></agpr-social-filter-input>
            <!-- Date -->
            <agpr-date-query-popup
                id="themeAnalytics"
                class="agpr-themeAnalytics-toolbar-dateFilter agpr-themeAnalytics-toolbar-dateFilter--noBorder"
                [(ngModel)]="searchDateRange"
                [options]="dateOptions"
                [toolTipLabel]="'Common.dateQueryInput.dateFilter'"
                [searchRange]="searchRange"
                [style]="agprComponentStyle.socialPlus"
                (ngModelChange)="dateRangeChanged($event)"
            >
            </agpr-date-query-popup>
            <div class="agpr-themeAnalytics-toolbar-spacer">
                <agpr-social-switch
                    *ngIf="isArchiveSearch"
                    [(ngModel)]="enableEngagementInsights"
                    (ngModelChange)="switchClick()"
                    onText="Social.agentWidget.archiveSearch.results.enableEngagement.label"
                    offText="Social.agentWidget.archiveSearch.results.enableEngagement.label"
                    [isArchiveSearch]="true"
                    iconTooltip="Social.agentWidget.archiveSearch.results.enableEngagement.tooltip"
                    id="enableEngagementInsightsSwitch"
                ></agpr-social-switch>
            </div>
        </div>
        <div class="agpr-themeAnalytics-toolbarRow agpr-themeAnalytics-toolbar-bottomRow">
            <agpr-filter-chips
                id="theme.filters"
                [style]="agprComponentStyle.social"
                [noContainerWhenEmpty]="true"
            ></agpr-filter-chips>
        </div>
    </div>
    @if (errorType === errorTypes.filters && filterError) {
        <div
        class="agpr-themeAnalytics-filtersError"
        >
        @if (filterError.filterTypes) {
            <agpr-message
            [severity]="messageSeverity.warning"
        >
            {{ 'Monitoring.result.filterError' | localize }}
            <ul class="agpr-themeAnalytics-filtersErrorList">
                <li
                    *ngFor="let filterType of filterError.filterTypes"
                >
                    {{ 'Monitoring.filtersLocalization.' + filterType | localize }}
                    @if (filterError.localizedInvalidValueMap) {
                        <ng-container>: {{ filterError.localizedInvalidValueMap.get(filterType).join(', ') }}</ng-container>
                    }
                </li>
            </ul>
        </agpr-message>
        }
        @else {
            <agpr-message
            [severity]="messageSeverity.warning"
            >
            {{ 'Monitoring.result.filterError.generic' | localize }}
            </agpr-message>
        }
    </div>
}
    <agpr-tabs
        [selectedTabIndex]="currentTabIndex"
        (selectedTabIndexChange)="changeTab($event)"
    >
        <div
            *ngIf="!isArchiveSearch"
            class="agpr-themeAnalytics-quotaExceededBanner"
        >
            <agpr-quota-exceeded-banner [id]="'analytics_quotaBanner'"></agpr-quota-exceeded-banner>
        </div>
        <agpr-tab
            [id]="'analytics-summary'"
            [icon]="'fa-regular fa-duotone fa-chart-tree-map'"
            [heading]="'Social.intelligence.themeAnalytics.summary'"
        >
            <agpr-theme-analytics-summary
                *ngIf="currentTabIndex === themeAnalyticsTabEnum.summary"
                [id]="id"
            ></agpr-theme-analytics-summary>
        </agpr-tab>
        <agpr-tab
            [id]="'analytics-sentiment'"
            [icon]="'fa-regular fa-duotone fa-face-smile'"
            [heading]="'Social.intelligence.themeAnalytics.sentiment'"
        >
            <agpr-theme-sentiment-analytics
                *ngIf="currentTabIndex === themeAnalyticsTabEnum.sentiment"
                [id]="id"
            ></agpr-theme-sentiment-analytics>
        </agpr-tab>
        <agpr-tab
            [id]="'analytics-engagement'"
            [icon]="'fa-kit-duotone fa-agpr-engage'"
            [heading]="'Social.intelligence.themeAnalytics.engagement'"
            [disabled]="isArchiveSearch && !enableEngagementInsights"
            [tooltip]="isArchiveSearch && !enableEngagementInsights ? 'Social.agentWidget.archiveSearch.results.charts.noEngagement.tooltip': ''"
        >
            <agpr-theme-engagement-analytics
                *ngIf="currentTabIndex === themeAnalyticsTabEnum.engagements"
                [id]="id"
            ></agpr-theme-engagement-analytics>
        </agpr-tab>
        <agpr-tab
            [id]="'analytics-trends'"
            [icon]="'fa-solid fa-duotone fa-arrow-trend-up'"
            [heading]="'Social.intelligence.themeAnalytics.trends'"
        >
            <agpr-theme-analytics-trends
                *ngIf="currentTabIndex === themeAnalyticsTabEnum.trends"
                [id]="id"
            ></agpr-theme-analytics-trends>
        </agpr-tab>
    </agpr-tabs>
</div>
